export default function removeToken(){
    sessionStorage.removeItem('token');
}